<template>
  <div class="keyboard">
    <div
      v-for="i in 88"
      :key="i + 20"
      :class="keyClass(i + 20)"
      :style="i === loadedSoundSize && !isLoadedSounds ? {
        transition: 'background-color .5s ease 0s !important'
      } : {}"
      @mousedown="actionVirtualKey(i + 20, true)"
      @mouseup="actionVirtualKey(i + 20, false)"
      @mouseout="actionVirtualKey(i + 20, false)"
    />
  </div>
</template>

<style lang="scss">
.keyboard {
  position: relative;
  height: calc(100vw / 88 * 8);

  > div {
    display: inline-block;
    transition: background-color .1s ease 0s;
  }
  .white-key {
    width: calc(100% / 52);
    height: 100%;
    background-color: #fff;
    border: 1px solid #000;
  }
  .black-key {
    position: absolute;
    width: calc(100% / 52 * 0.478);
    height: 63.3%;
    margin-left: calc(-100% / 52 * 0.478 / 2);
    background-color: #000;
    border: 1px solid #000;
  }
  .key-disabled {
    background-color: #c3c3c3;
  }
  .key-active {
    background-color: #fff666;
    transition: initial !important;
  }
}
</style>

<script>
export default {
  name: 'Keyboard',
  props: {
    loadedSoundSize: {
      type: Number,
      default: 0
    },
    actionVirtualKey: {
      type: Function,
      default: () => {}
    }
  },
  data: () => ({
    isLoadedSounds: false
  }),
  watch: {
    async loadedSoundSize(val) {
      if (val === 88) {
        await new Promise(resolve => setTimeout(resolve, 500));
        this.isLoadedSounds = true;
      }
    }
  },
  methods: {
    getKeyName(n) {
      const pitcheArr = ['C', 'C#', 'D', 'D#', 'E', 'F', 'F#', 'G', 'G#', 'A', 'A#', 'B'];
      return pitcheArr[n%12] + Math.floor((n - 12)/12);
    },
    keyClass(n) {
      let keyClass = [1, 3, 6, 8, 10].includes(n%12) ? 'black-key' : 'white-key';
      keyClass += this.loadedSoundSize + 20 < n ? ' key-disabled' : '';
      return keyClass;
    }
  }
};
</script>
